export default __webpack_public_path__ + "assets/pdf/cvWebsiteSchottenhammer.63b5dd8b.pdf";